var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYogaPose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.415 6.33773C13.6116 6.33773 14.5816 5.36768 14.5816 4.17106C14.5816 2.97444 13.6116 2.00439 12.415 2.00439C11.2183 2.00439 10.2483 2.97444 10.2483 4.17106C10.2483 5.36768 11.2183 6.33773 12.415 6.33773Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7034 12.924C10.6864 12.3378 10.4393 11.7819 10.0156 11.3764C9.59187 10.9709 9.02559 10.7486 8.43921 10.7574L3.74837 10.3673C3.46105 10.3673 3.1855 10.2532 2.98234 10.05C2.77918 9.84689 2.66504 9.57133 2.66504 9.28402C2.66504 8.9967 2.77918 8.72115 2.98234 8.51798C3.1855 8.31482 3.46105 8.20068 3.74837 8.20068H22.165C22.4524 8.20068 22.7279 8.31482 22.9311 8.51798C23.1342 8.72115 23.2484 8.9967 23.2484 9.28402C23.2484 9.57133 23.1342 9.84689 22.9311 10.05C22.7279 10.2532 22.4524 10.3673 22.165 10.3673L17.6692 10.7032C17.2943 10.7588 16.9496 10.9403 16.6916 11.2179C16.4337 11.4956 16.2779 11.8527 16.25 12.2307C16.1632 13.2717 16.301 14.3193 16.6543 15.3025C17.0075 16.2856 17.5679 17.1813 18.2975 17.929L22.5225 22.2623C22.7614 22.5072 22.8951 22.8357 22.8951 23.1778C22.8951 23.5198 22.7614 23.8483 22.5225 24.0932C22.2831 24.3392 21.9579 24.4833 21.6148 24.4954C21.2716 24.5075 20.9371 24.3867 20.6809 24.1582L13.8342 18.2649H6.80337V23.129C6.79489 23.4624 6.65648 23.7792 6.41766 24.012C6.17884 24.2447 5.85852 24.375 5.52504 24.3748C5.35859 24.3748 5.19377 24.3421 5.03999 24.2784C4.88621 24.2147 4.74648 24.1213 4.62878 24.0036C4.51108 23.8859 4.41772 23.7462 4.35402 23.5924C4.29032 23.4386 4.25754 23.2738 4.25754 23.1073V16.6073C4.2542 16.3477 4.34424 16.0955 4.51127 15.8966C4.6783 15.6978 4.9112 15.5655 5.16754 15.524C7.17993 15.1963 9.22595 15.1272 11.2559 15.3182",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYogaPose);
export default __webpack_public_path__ + "static/media/yoga-pose.a67ce5803f67910541d46f0258c93cd6.svg";
export { ForwardRef as ReactComponent };